import AssetTypeTags from "./AssetTypeTags";
import AssetPopoverLink, { LinksType } from "./AssetPopoverLink";
import styles from "./AssetTopRow.module.scss";
import ExpirationMessage from "./ExpirationMessage";
import {
  License,
  ManageAsset,
} from "../../api/decimal/common-types/manageAssets.ts";
import clsx from "clsx";

interface BaseProps {
  license?: License;
  links: LinksType;
  compact?: boolean;
}

type Props =
  | (BaseProps & { asset: ManageAsset; explore?: VST.Bridge.Asset })
  | (BaseProps & { asset?: undefined; explore: VST.Bridge.Asset });

export default function AssetTopRow({
  asset,
  links,
  license,
  explore,
  compact,
}: Props) {
  const commonAsset = asset ?? explore;
  return (
    <div className={styles.row}>
      <div className={clsx(styles.left, compact && styles.compactLeft)}>
        <AssetTypeTags asset={commonAsset} className={styles.tags} />
        {license && <ExpirationMessage license={license} explore={explore} />}
      </div>
      <AssetPopoverLink
        asset={commonAsset}
        className={styles.threeDot}
        links={links}
      />
    </div>
  );
}
